<table [ngStyle]="bgClass">
  <!-- Table Header -->
  <thead>
    <tr>
      <th
        *ngFor="let column of columns; let i = index"
        [attr.id]="'col-' + i"
        scope="col"
        [ngClass]="{ 'is-zoomed': isZoomed }"
        [ngStyle]="headersStyle"
      >
        {{ column.header }}
      </th>
    </tr>
  </thead>

  <!-- Table body -->
  <tbody>
    <tr *ngFor="let row of data">
      <td
        *ngFor="let column of columns; let colIndex = index"
        [attr.headers]="'col-' + colIndex"
        [ngClass]="[column.class, isZoomed ? 'is-zoomed' : '']"
      >
        <app-column
          [row]="row"
          [field]="column.field"
          [type]="column.type"
        ></app-column>
      </td>
    </tr>
  </tbody>
</table>
